<script setup lang="ts">
import { useCustomFieldProps } from '@satellite/composables/useCustomFieldProps';

import type { CustomFieldProps } from '../types';
import CustomFieldInputBase from '../CustomFieldInputBase.vue';

/**
 * Action field type - feature link/button
 * TODO: Implement action routing/navigation
 */
const props = defineProps<CustomFieldProps>();

const emit = defineEmits<{
  'update:model-value': [value: string];
  /** @deprecated Use update:model-value instead */
  // TODO: Remove this event after the migration is complete
  input: [value: string];
  action: [];
}>();

const { normalizedProps } = useCustomFieldProps(props);

function handleAction() {
  emit('action');
  emit('update:model-value', 'clicked');
  emit('input', 'clicked');
}
</script>

<template>
  <custom-field-input-base :field="field" v-bind="normalizedProps">
    <div class="custom-field-action">
      <v-btn
        color="primary"
        variant="outlined"
        :disabled="normalizedProps.readOnly"
        @click="handleAction">
        <v-icon start>mdi-link-variant</v-icon>
        {{ field.label || 'Action' }}
      </v-btn>
    </div>
  </custom-field-input-base>
</template>

<style scoped lang="scss">
.custom-field-action {
  width: 100%;
}
</style>
